module.exports = __webpack_public_path__ + "img/bridge6.7d8b82ec.png";